import { render, staticRenderFns } from "./ThirdPartyList.vue?vue&type=template&id=7baf679c&"
import script from "./ThirdPartyList.vue?vue&type=script&lang=js&"
export * from "./ThirdPartyList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports